export default "__VITE_ASSET__BGqtN754__"